// extracted by mini-css-extract-plugin
export default {"container":"Series3App_container__baCAz","main":"Series3App_main__QOeGw"};